import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Scroll from 'react-scroll';
import { isValid, getFormSyncErrors, getFormValues, touch } from 'redux-form';
import classnames from 'classnames';
import {
  Container,
  Grid,
  GridColumn,
  Dimmer,
  Loader,
  Button,
  Icon,
} from 'semantic-ui-react';
import MobileTips from './common/MobileTips';
import * as formStructureActions from '../store/formStructure/formStructureActions';
import * as showSeasonActions from '../store/showSeason/showSeasonActions';
import Step1 from './apply/Step1.js';
import Step2 from './apply/Step2.js';
import Step3 from './apply/Step3.js';
import Step4 from './apply/Step4.js';
import { Redirect } from 'react-router';
const tips =
  '<div><p> Vergewissere dich, dass alle Angaben korrekt sind, bevor du zum nächsten Schritt übergehst! </p> <p> Aktualisiere den Browser nicht, während du die Bewerbung ausfüllst. Andernfalls geht der Bewerbungsfortschritt verloren und du musst erneut beginnen. </p> </div>';

class Apply extends PureComponent {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    show: PropTypes.object.isRequired,
    season: PropTypes.object.isRequired,
    sections: PropTypes.object.isRequired,
    getFormInformation: PropTypes.func.isRequired,
    applicants: PropTypes.number.isRequired,
    optionByField: PropTypes.object.isRequired,
    finalForm: PropTypes.object.isRequired,
    setFormTouch: PropTypes.func.isRequired,
    submitApplicants: PropTypes.func.isRequired,
    termsOfServiceForm: PropTypes.object,
    confirmAuthorizationForm: PropTypes.object,
    country: PropTypes.string.isRequired,    
  };
  static defaultProps = {
    termsOfServiceForm: {},
    confirmAuthorizationForm: {},
  };
  constructor(props) {
    super(props);
    this.scroller = Scroll.scroller;
    this.stepsCount = process.env.REACT_APP_SKIP_PHOTO == "1" ? 3 : 4;
    this.showName = process.env.REACT_APP_SHOW_ID === "ly224f28-795e-4dcd-bb67-38e7e9cc773c" ? "Dating Naked" : "Germany Shore";
    this.state = {
      stepIndex: 1,
      tabIndex: 0,
      visible: false,
      isFinalStep: false,
      tabsBySteps: {
        1: this.props.applicants,
        2: this.props.applicants - 1,
        3: this.stepsCount === 3 ? 0 : this.props.applicants,
        4: this.stepsCount === 4 ? 0 : -1,
       },
      skipPhoto: this.stepsCount === 3,
      stepsCount : this.stepsCount,
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.props.season.externalIdC && this.props.country) {
      this.props.getFormInformation(this.props.season.externalIdC, this.props.country);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      (this.props.season.externalIdC &&
        prevProps.season.externalIdC !== this.props.season.externalIdC) ||
      (this.props.country && prevProps.country !== this.props.country)
    ) {
      this.props.getFormInformation(
        this.props.season.externalIdC,
        this.props.country
      );
    }
  }

  setStepIndex = index => {
    if (this.props.applicants > 1) {
      if (index > 0) {
        if (
          this.state.tabIndex < this.state.tabsBySteps[this.state.stepIndex]
        ) {
          this.setState({ tabIndex: this.state.tabIndex + index });
            if (this.state.stepIndex === this.state.stepsCount) {
            this.setState({ isFinalStep: true });
          } else {
            this.setState({ isFinalStep: false });
          }
        } else {
          this.setState({ tabIndex: 0 });
          this.setState({ stepIndex: this.state.stepIndex + index });
            if (this.state.stepIndex + index === this.state.stepsCount) {
            this.setState({ isFinalStep: true });
          } else {
            this.setState({ isFinalStep: false });
          }
        }
      } else if (this.state.tabIndex > 0) {
        this.setState({ tabIndex: this.state.tabIndex + index });
        this.setState({ isFinalStep: false });
      } else {
        this.setState({
          tabIndex: this.state.tabsBySteps[this.state.stepIndex - 1],
        });
        this.setState({ stepIndex: this.state.stepIndex + index });
        this.setState({ isFinalStep: false });
      }
    } else {
      this.setState({ stepIndex: this.state.stepIndex + index });
        if (this.state.stepIndex + index === this.state.stepsCount) {
        this.setState({ isFinalStep: true });
      } else {
        this.setState({ isFinalStep: false });
      }
    }
  };

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  closeMenu = () => this.setState({ visible: false });

  changeStep = index => {
    this.scroller.scrollTo('applyProgress', {
      duration: 500,
      delay: 100,
      smooth: true,
    });
    if (index > 0) {
      if (this.props.applicants === 1) {
        if (this.props[`member${this.state.tabIndex + 1}IsValid`]) {
          this.setStepIndex(index);
        } else {
          this.props.setFormTouch(
            `member${this.state.tabIndex + 1}`,
            Object.keys(
              this.props[`member${this.state.tabIndex + 1}SyncErrors`]
            )
          );
        }
      } else {
        let formName = `member${this.state.tabIndex + 1}`;
        if (
          (this.state.tabIndex === this.props.applicants &&
            this.state.stepIndex !== 2) ||
            (this.props.applicants > 1 && this.state.stepIndex === this.state.stepsCount)
        ) {
          formName = 'team';
        }
        if (this.props[`${formName}IsValid`]) {
          this.setStepIndex(index);
        } else {
          this.props.setFormTouch(
            `${formName}`,
            Object.keys(this.props[`${formName}SyncErrors`])
          );
        }
      }
    } else {
      this.setStepIndex(index);
    }
  };

  submit = () => {
    if (this.props.applicants === 1) {
      if (
        this.props[`member${this.state.tabIndex + 1}IsValid`] &&
        this.props.termsOfServiceForm.termsOfService &&
        this.props.confirmAuthorizationForm.confirmAuthorization
      ) {
        this.props.submitApplicants(this.props.finalForm);
      } else {
        this.props.setFormTouch(
          `member${this.state.tabIndex + 1}`,
          Object.keys(this.props[`member${this.state.tabIndex + 1}SyncErrors`])
        );
        this.props.setFormTouch('termsOfServiceForm', ['termsOfService']);
        this.props.setFormTouch('confirmAuthorizationForm', ['confirmAuthorization']);
        
      }
    } else {
      let formName = `member${this.state.tabIndex + 1}`;
        if (this.state.tabIndex === 0 && this.state.stepIndex === this.state.stepsCount) {
        formName = 'team';
      }
      if (
        this.props[`${formName}IsValid`] &&
        this.props.termsOfServiceForm.termsOfService &&
        this.props.confirmAuthorizationForm.confirmAuthorization
      ) {
        this.props.submitApplicants(this.props.finalForm);
      } else {
        this.props.setFormTouch(
          `${formName}`,
          Object.keys(this.props[`${formName}SyncErrors`])
        );
        this.props.setFormTouch('termsOfServiceForm', ['termsOfService']);
        this.props.setFormTouch('confirmAuthorizationForm', ['confirmAuthorization']);
      }
    }
  };

  renderTips() {
    return (
      <GridColumn className="ui sixteen wide mobile five wide computer right floated">
        <div className="ui fluid card noShadow tip">
          <div
            className="content invertedPrimary"
            style={{ backgroundColor: `#${this.props.season.hexColorCodeC}` }}
          >
            <div className="header">
              <h4>Tipp</h4>
            </div>
          </div>
          <div className="content shaded padded">
            <p>
              Vergewissere dich, dass alle Angaben korrekt sind, bevor du zum nächsten Schritt übergehst!{' '}
            </p>
            <p>
              Aktualisiere den Browser nicht, während du die Bewerbung ausfüllst. Andernfalls geht der Bewerbungsfortschritt verloren und du musst erneut beginnen.{' '}
            </p>
          </div>
        </div>
      </GridColumn>
    );
  }

  render() {
    const { show, season, sections, loading, optionByField } = this.props;
    const { Element } = Scroll;
    const IsGermanShoreShow =
      process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';

    if(!this.props.country) {
      return (
      <Redirect to="/home"/>
      );
    }
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader size="large">Loading</Loader>
        </Dimmer>
      );
    }
    return (
      <div>
        <Container id="mainContent" className="ui">
          <Grid className="ui">
            <GridColumn className="pageShowTitle">
              <h3
                className="ui dividing header"
                style={{ color: `#${season.hexColorCodeC}` }}
              >
                {show.name} Casting
              </h3>
              <Button
                onClick={this.toggleVisibility}
                id="applyToggle"
                className="tiny ui primary tablet-down mobileToggle"
              >
                <Icon className="sidebar" />
                Tipp
              </Button>
            </GridColumn>
          </Grid>

          <MobileTips
            tips={tips}
            hexColorCodeC={season.hexColorCodeC}
            visible={this.state.visible}
            toggleVisibility={this.toggleVisibility}
          />

          <Grid className="ui stackable" onClick={this.closeMenu}>
            <GridColumn className="ui sixteen wide mobile eight wide computer">
              <h1>Bewirb dich hier!</h1>
              <p className="lead">Willkommen bei der Bewerbung für {this.showName}.</p>
              <p>
                Deine Bewerbung muss in {' '}
                <strong style={{ color: `#${season.hexColorCodeC}` }}>
                  EINER
                </strong>{' '} Sitzung erledigt werden. Bitte stelle sicher, dass du ein Bild von dir und ein Standardvideo auf deinemDesktop gespeichert hast, damit du es der Bewerbung leicht hinzufügen können.  
              </p>

              <p>
                {IsGermanShoreShow ? 'Bitte lade keine Videos oder Bilder hoch, die Nacktheit zeigen oder Inhalte enthalten, die für dich selbst unangenehm oder unangemessen sein könnten. ' : 'Wenn Du eine andere Person bewirbst, musst du deren Zustimmung einholen. Wenn die Bewerbung Angaben (einschließlich Bilder) zu anderen Personen als Ihnen enthält, musst du das Einverständnis jeder Person für die Bereitstellung dieser Angaben einholen.'}
              </p>

              <div className="apply">
                <Element name="applyProgress">
                  <div className="applyProgress">
                    <div
                      className={classnames('applyStep', {
                        active: this.state.stepIndex === 1,
                      })}
                    >
                      <span>1</span>
                    </div>
                    <div
                      className={classnames('applyStep', {
                        active: this.state.stepIndex === 2,
                      })}
                    >
                      <span>2</span>
                    </div>
                    <div
                      className={classnames('applyStep', {
                        active: this.state.stepIndex === 3,
                      })}
                    >
                      <span>3</span>
                    </div>
                    {!(this.state.skipPhoto) && (
                    <div
                      className={classnames('applyStep', {
                        active: this.state.stepIndex === 4,
                      })}
                    >
                      <span>4</span>
                    </div>
                    )}
                  </div>
                </Element>
                {this.state.stepIndex === 1 && (
                  <Step1
                    season={season}
                    sections={sections}
                    hexColorCodeC={season.hexColorCodeC}
                    optionByField={optionByField}
                    applicants={this.props.applicants}
                    tabIndex={this.state.tabIndex}
                    setTabIndex={() => {}}
                  />
                )}
                {this.state.stepIndex === 2 && (
                  <Step2
                    sections={sections}
                    hexColorCodeC={season.hexColorCodeC}
                    optionByField={optionByField}
                    applicants={this.props.applicants}
                    tabIndex={this.state.tabIndex}
                    setTabIndex={() => {}}
                  />
                )}
                {this.state.stepIndex === 3 && !(this.state.skipPhoto) && (
                  <Step3
                    season={season}
                    sections={sections}
                    hexColorCodeC={season.hexColorCodeC}
                    optionByField={optionByField}
                    applicants={this.props.applicants}
                    tabIndex={this.state.tabIndex}
                    setTabIndex={() => {}}
                  />
                )}
                {((this.state.stepIndex === 3 && this.state.skipPhoto) || (this.state.stepIndex === 4)) && (
                  <Step4
                    season={season}
                    sections={sections}
                    hexColorCodeC={season.hexColorCodeC}
                    optionByField={optionByField}
                    applicants={this.props.applicants}
                    tabIndex={this.state.tabIndex}
                    setTabIndex={() => {}}
                  />
                )}
              </div>
              <div className="ui grid applyNav">
                <div className="eight wide mobile six wide tablet six wide computer column">
                  {(this.state.stepIndex > 1 || this.state.tabIndex) > 0 && (
                    <div
                      className="ui fluid huge left labeled icon button"
                      onClick={() => this.changeStep(-1)}
                    >
                      <i className="left chevron icon" />
                      {IsGermanShoreShow ? 'Zurück' : 'Back' }
                    </div>
                  )}
                </div>
                <div className="eight wide mobile six wide tablet six wide computer column">
                  {!this.state.isFinalStep && (
                    <div
                      className="ui fluid huge primary right labeled icon button"
                      style={{ backgroundColor: `#${season.hexColorCodeC}` }}
                      onClick={() => this.changeStep(1)}
                    >
                      <i className="right chevron icon" />
                      {IsGermanShoreShow ? 'Nächste' : 'Next' }
                    </div>
                  )}
                  {this.state.isFinalStep && (
                    <div
                      className="ui fluid huge primary right labeled icon button"
                      style={{ backgroundColor: `#${season.hexColorCodeC}` }}
                      onClick={this.submit}
                    >
                      <i className="right chevron icon" />
                      Bewerbung abschicken
                    </div>
                  )}
                </div>
              </div>
            </GridColumn>

            {this.renderTips()}
          </Grid>
        </Container>
      </div>
    );
  }
}

const mapStatesToProps = state => {
  const newState = {
    sections: state.formStructure.sections,
    optionByField: state.formStructure.optionByField,
    applicants: state.showSeason.applicants,
    loading: state.formStructure.loading,
    termsOfServiceForm: getFormValues('termsOfServiceForm')(state),
    confirmAuthorizationForm: getFormValues('confirmAuthorizationForm')(state),
    finalForm: {
      members: [],
      team: [],
    },
    country: state.country.selected,
  };
  for (let i = 0; i < state.showSeason.applicants; i++) {
    newState[`member${i + 1}IsValid`] = isValid(`member${i + 1}`)(state);
    newState[`member${i + 1}SyncErrors`] = getFormSyncErrors(`member${i + 1}`)(
      state
    );
    newState.finalForm.members.push(getFormValues(`member${i + 1}`)(state));
  }
  if (state.showSeason.applicants > 1) {
    newState.teamIsValid = isValid('team')(state);
    newState.teamSyncErrors = getFormSyncErrors('team')(state);
    newState.finalForm.team.push(getFormValues('team')(state));
  }

  return newState;
};

const mapDispatchToProps = dispatch => ({
  getFormInformation: (seasonId, countrySfId) =>
    dispatch(formStructureActions.getFormBySeason(seasonId, countrySfId)),
  submitApplicants: applicants =>
    dispatch(showSeasonActions.submitApplicants(applicants)),
  setFormTouch: (formName, fields) => dispatch(touch(formName, ...fields)),
});

export default connect(mapStatesToProps, mapDispatchToProps)(Apply);



// WEBPACK FOOTER //
// ./src/components/Apply.js